import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrAddPermissionValidFromState = atom({
  key: "myHrAddPermissionValidFromState",
  default: {
    value: new Date(),
    error: false,
    errorText: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
